/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { ContractsTabelHeader } from './ContractsTableHeader';
import { contractsGridLabel } from './ConstantData';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { useHistory, Link } from 'react-router-dom';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
  selectedType,
  dispatchCellClick,
} from '../../../Maintain/Contract/store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

const Contracts = (props) => {
  const dispatch = useDispatch();
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const { fullScreenView, handleFullScreenView } = props;
  const [gridApi, setGridApi] = useState(null);
  const [hoverUnder, setHoverUnder] = React.useState(false);
  const history = useHistory();
  // on grid ready for contracts table
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  // go to particular contract details action button handler function
  const moveToContractPage = (selectedRows) => {
    dispatch(dispatchCellClick(true));
    dispatch(selectedType('C'));
    searchContractState.contractType = 'onSelect';
    searchContractState.selectedContractType = 'contractId';
    searchContractState.selectedRowData = selectedRows?.data?.contractSeqNum;
    searchContractState.selectedContractId = selectedRows?.data?.contractSeqNum;
    searchContractState.rebateProgramCode = null;
    searchContractState.searchContractDate = selectedRows?.data?.startDt
      ? moment(new Date(selectedRows.data.startDt)).format('MM/DD/YYYY')
      : null;
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/createContract',
      value: 'Maintain Contract',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/createContract',
    });
  };
  // ag-grid frame work component
  const frameworkComponents = {
    ContractIdRenderer: (cellInfo) => {
      return (
        <div className={hoverUnder ? 'frr-text-decoration-underline' : ''}>
          <Link
            to='#'
            role='button'
            onClick={() => {
              moveToContractPage(cellInfo);
            }}
            onMouseOver={() => {
              setHoverUnder(true);
            }}
            onMouseOut={() => {
              setHoverUnder(false);
            }}
          >
            {cellInfo && cellInfo.value}
          </Link>
        </div>
      );
    },
    StateDateRenderer: (cellInfo) => {
      if (cellInfo.value !== null && cellInfo.value !== '') {
        return (
          <div className='tdCell icon-btn-group'>
            <span className='td-date-range'>
              {moment(cellInfo.value).format('MM/DD/YYYY')}
              {'   '} <SVGComponent iconName='Icon_date-range' />
            </span>
          </div>
        );
      }
      return null;
    },
    EndDateRenderer: (cellInfo) => {
      if (cellInfo.value !== null && cellInfo.value !== '') {
        return (
          <div className='tdCell icon-btn-group'>
            <span className='td-date-range'>
              {moment(cellInfo.value).format('MM/DD/YYYY')}
              {'   '} <SVGComponent iconName='Icon_date-range' />
            </span>
          </div>
        );
      }
      return null;
    },
    ContractNameRenderer: (cellInfo) => {
      if (
        cellInfo.value !== null &&
        cellInfo.value !== '' &&
        cellInfo.value.length > 50
      ) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{cellInfo.value}</Tooltip>}
          >
            <div>
              {cellInfo.value && cellInfo.value.substring(0, 50) + '...'}
            </div>
          </OverlayTrigger>
        );
      } else {
        return <div>{cellInfo.value}</div>;
      }
    },
  };
  return (
    <div className='row' data-testid='contract-table-grid-component'>
      <div className='col-sm-12'>
        <TableGridWithFeatures
          data-testid='contact-anomalies-contracts-grid'
          rowSelection={'single'}
          rowMultiSelectWithClick={false}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
          gridCall={onGridReady}
          rowData={props.contractValues}
          columnDefs={ContractsTabelHeader}
          frameworkComponents={frameworkComponents}
          exportFile={true}
          animateRows={true}
          sideBar={false}
          fileName={contractsGridLabel}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown={true}
          suppressCellFocus={true}
          onCellFocused={onCellFocused}
          onFilterData={false}
        />
      </div>
    </div>
  );
};
export default Contracts;
